import React from 'react';
import moment from 'moment';
import 'moment/locale/de';
import 'moment/locale/nb';

interface DateTimeCellProps {
  params: string;
}

const DateTimeCell: React.FC<DateTimeCellProps> = (props) => {
  const plainDate = props.params;
  const language = localStorage.getItem('i18nextLng');

  if (!plainDate) {
    return <span>-</span>;
  }

  if (language === 'no') {
    moment.locale('nb');
  } else if (language === 'de') {
    moment.locale('de');
  } else {
    moment.locale('en');
  }

  return <span>{moment(plainDate).format('lll')}</span>;
};

export default DateTimeCell;
